// Priority: 1. window.appSyncConfig (injected via /config.js on S3 or via dev-server)
export const appSyncConfig = window.appSyncConfig;

export const STORE_LINKS = {
    ios: 'https://apps.apple.com/us/app/splitpal-tabs/id6748889469',
    android: 'https://play.google.com/store/apps/details?id=com.legendarybytes.splitpal.tabs&pcampaignid=web_share'
};

export const IMAGE_COMPRESSION_CONFIG = {
    maxSizeMB: 1.0,
    maxWidth: 1920,
    maxHeight: 1080,
    quality: 0.75
};